import { useQuery } from '@tanstack/react-query'
import { adminApi } from '../adminApi.js'
import type { AuditLogResponse } from '../types.js'

export interface AuditLogFilters {
  tenant_id?: string
  admin_id?: string
  action?: string
  from?: string
  to?: string
  impersonation_only?: boolean
  cursor?: string
  limit?: number
}

export const auditLogKey = (filters: AuditLogFilters) =>
  ['admin', 'audit-log', 'full', filters] as const

function buildQuery(filters: AuditLogFilters): string {
  const params = new URLSearchParams()
  if (filters.tenant_id) params.set('tenant_id', filters.tenant_id)
  if (filters.admin_id) params.set('admin_id', filters.admin_id)
  if (filters.action) params.set('action', filters.action)
  if (filters.from) params.set('from', filters.from)
  if (filters.to) params.set('to', filters.to)
  if (filters.impersonation_only) params.set('impersonation_only', 'true')
  if (filters.cursor) params.set('cursor', filters.cursor)
  if (filters.limit) params.set('limit', String(filters.limit))
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}

/**
 * Full audit-log query for the standalone /admin/audit-log page. Cursor
 * pagination is driven by the page component swapping `cursor` in `filters`.
 */
export function useAuditLog(filters: AuditLogFilters) {
  return useQuery({
    queryKey: auditLogKey(filters),
    queryFn: () =>
      adminApi.get<AuditLogResponse>(`/audit-log${buildQuery(filters)}`),
  })
}
